<template>
  <div class='menu'>
    <el-tree
      :data="dictionaryData"
      :props="defaultProps"
      accordion
      node-key="itemid"
      ref="dataConfigTree"
      :highlight-current="true"
      @node-click="handleNodeClick"
      class="tree"
    >
      <span
        class="custom-tree-node"
        slot-scope="{ node, data }"
      >
        <span :title="node.label">{{ node.label }}</span>
      </span>
    </el-tree>
  </div>
</template>
<script>
import Api from '../api/index'


export default {
  data () {
    return {
      dictionaryData: [],
      defaultProps: {
        children: 'children',
        label: 'itemname',
        disabled: 'isenable'
      }
    }
  },

  created () {
    this.getDataDictionary();

  },
  mounted () {

  },
  methods: {
    async getDataDictionary () {
      const res = await Api.dictionary.getDataDictionary()
      if (!res.success) return
      this.dictionaryData = res.rows

    },
    async handleNodeClick (data) {
      this.$store.state.itemid = data.itemid
      const res = await Api.dictionary.GetDataItemDetailTreeList(data.itemid)
      this.$store.state.treeList = res.rows
      this.$refs.dataConfigTree.setCurrentKey(data.itemid)
    }

  }

}
</script>
<style lang='less' scoped>
ul {
  li {
    padding: 10px 20px;
    display: inline-block;
    width: 100%;
    height: 100%;
  }
  li > a:hover {
    background-color: #87cefa;
    color: #fff !important;
  }
}
.current {
  color: #fff !important;
  font-weight: bold !important;
  background-color: #87cefa;
}
.origin {
  color: #000;
  font-weight: normal;
}
/deep/.tree > .el-tree-node > .el-tree-node__content {
  height: 40px;
  line-height: 40px;
}
/deep/.tree > .el-tree-node > .el-tree-node__children > .el-tree-node {
  margin: 10px 0;
}
/deep/.el-tree-node__content {
  &:hover {
    background: #d5e8fc;
  }
}
/deep/.el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #3498db !important;
  color: #fff;
}
</style>